import { render, staticRenderFns } from "./guidelinesPage.vue?vue&type=template&id=50467a62&scoped=true&"
import script from "./guidelinesPage.vue?vue&type=script&lang=ts&"
export * from "./guidelinesPage.vue?vue&type=script&lang=ts&"
import style0 from "./guidelinesPage.vue?vue&type=style&index=0&id=50467a62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50467a62",
  null
  
)

export default component.exports